module.exports = __webpack_public_path__ + "static/media/mr.55d8f233.svg";